import React from "react";
import { motion } from "framer-motion";
import { Section } from "./Section";
import { experience } from "../../data/portfolio";

export const Experience = () => {
  return (
    <Section
      id="experience"
      label="Trajectory"
      title="Where I've put the hours."
      index={4}
    >
      <ol className="relative pl-6 md:pl-10 border-l border-neutral-900">
        {experience.map((e, i) => (
          <motion.li
            key={e.year + e.role}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.05 }}
            data-testid={`timeline-item-${i}`}
            className="relative pb-14 md:pb-16 last:pb-0 group"
          >
            <span
              aria-hidden
              className="absolute -left-[33px] md:-left-[45px] top-2 w-3 h-3 bg-neutral-950 border border-neutral-700 group-hover:bg-neutral-100 group-hover:border-neutral-100 transition-colors"
            />
            <span
              aria-hidden
              className="hidden md:block absolute -left-[39px] top-3.5 w-6 border-t border-neutral-800"
            />

            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10">
              <div className="md:col-span-3">
                <span className="text-mono-label">{e.year}</span>
              </div>
              <div className="md:col-span-9 space-y-3">
                <h3 className="font-serif text-2xl md:text-[1.65rem] leading-tight tracking-tight text-neutral-100">
                  {e.role}
                </h3>
                <div className="font-mono text-xs uppercase tracking-[0.18em] text-neutral-500">
                  {e.org}
                </div>
                <p className="text-neutral-400 leading-relaxed max-w-2xl">
                  {e.summary}
                </p>
                <div className="flex flex-wrap gap-2 pt-1">
                  {e.tags.map((t) => (
                    <span
                      key={t}
                      className="border border-neutral-800 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-neutral-400"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </motion.li>
        ))}
      </ol>
    </Section>
  );
};

export default Experience;
